import { Body, Container, Header } from './components';

const App = () => {
  return (
    <Container>
      <Header></Header>
      <Body>Hello, welcome to Noman Land!</Body>
    </Container>
  );
};

export default App;
